module.exports = __webpack_public_path__ + "static/media/logo.c71ce839.svg";